(function(){
  function pad(n){return String(n).padStart(2,'0')}
  function tick(){
    var now=new Date();var end=new Date(now);end.setHours(24,0,0,0);
    var s=Math.max(0,Math.floor((end-now)/1000));
    var d=Math.floor(s/86400),h=Math.floor(s%86400/3600),m=Math.floor(s%3600/60),sec=s%60;
    document.querySelectorAll('[data-fdt-cd]').forEach(function(el){
      var f=el.querySelectorAll('b');
      if(f.length===4){f[0].textContent=pad(d);f[1].textContent=pad(h);f[2].textContent=pad(m);f[3].textContent=pad(sec);}
      else if(f.length===3){f[0].textContent=pad(h);f[1].textContent=pad(m);f[2].textContent=pad(sec);}
    });
  }
  tick();setInterval(tick,1000);

  function initSticky(){
    document.querySelectorAll('[data-fdt-sticky2]').forEach(function(bar){
      if(bar.dataset.ready)return;bar.dataset.ready=1;
      var btn=document.querySelector('.product-form__submit');
      var b=bar.querySelector('button');
      if(b)b.addEventListener('click',function(){
        var t=document.querySelector('.product-form__submit');
        if(t){t.click()}else{window.scrollTo({top:0,behavior:'smooth'})}
      });
      if(btn&&'IntersectionObserver' in window){
        new IntersectionObserver(function(en){en.forEach(function(x){
          bar.classList.toggle('is-visible',!x.isIntersecting&&x.boundingClientRect.top<0);
        })}).observe(btn);
      }
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initSticky)}else{initSticky()}

  document.addEventListener('click',function(e){
    var a=e.target.closest&&e.target.closest('a[href="#fdt-top"]');
    if(a){e.preventDefault();var f=document.querySelector('.product-form__submit')||document.body;f.scrollIntoView({behavior:'smooth',block:'center'})}
  });
})();
